import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";

import { BackInStockFacade } from "./facades/back-in-stock.facade";
import {
    BACK_IN_STOCK_FEATURE_KEY,
    backInStockReducer,
} from "./reducers/back-in-stock.reducer";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(BACK_IN_STOCK_FEATURE_KEY, backInStockReducer),
    ],
    providers: [BackInStockFacade],
})
export class BackInStockStateModule {}
